import { Address, Asset } from 'nftx.js';
import AssetImage from './AssetImage';
import { HTMLAttributes } from 'react';
import AssetImageContainer from './AssetImageContainer';

interface Props
  extends HTMLAttributes<any>,
    Pick<Partial<Asset>, 'imageUrl' | 'name'> {
  assetAddress: Address;
  tokenId: `${number}`;
  className?: string;
}

const AssetImageWrapper = ({ name, ...props }: Props) => {
  if ('imageUrl' in props) {
    return (
      <AssetImage
        imageUrl={props.imageUrl}
        {...props}
        name={name ?? ''}
        isLoading={false}
      />
    );
  }

  return <AssetImageContainer {...props} />;
};

export default AssetImageWrapper;
